import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import getFolderTable from '../../selectors/getFolderTable';
import type { MailFolder } from 'owa-graph-schema';

/**
 * Creates the Folder by adding client specific properties
 *
 * @param rawFolder Folder object
 */
export function createOrGetFolder(rawFolder: MailFolder): MailFolder {
    const folder = getFolderTable().get(rawFolder.id);

    // A fully added shared mailbox can first be materialized through the shared-folder tree.
    // Prefer later coprincipal data while retaining client-only state from the existing folder.
    if (
        folder &&
        folder.mailboxInfo?.type === 'SharedMailbox' &&
        rawFolder.mailboxInfo?.type === 'UserMailbox'
    ) {
        return {
            ...folder,
            mailboxInfo: rawFolder.mailboxInfo,
        };
    }

    // If the folder already exists in the table, return it
    // If unified inbox, we don't want the cached version since folder's mailboxInfos may differ
    // and we want to ensure we return the latest version with correct mailboxInfo
    if (folder && !isUnifiedInboxMailboxInfo(folder.mailboxInfo)) {
        const replicaGuid = rawFolder.replicaList?.[0];
        if (
            rawFolder.mailboxInfo.type === 'ArchiveMailbox' &&
            replicaGuid &&
            (folder.replicaList?.[0] !== replicaGuid ||
                folder.mailboxInfo.auxiliaryMailboxGuid !== replicaGuid)
        ) {
            return {
                ...folder,
                replicaList: rawFolder.replicaList,
                mailboxInfo: {
                    ...folder.mailboxInfo,
                    ...rawFolder.mailboxInfo,
                    auxiliaryMailboxGuid: replicaGuid,
                },
            };
        }

        return folder;
    }

    return {
        childFolderIds: [],
        ...rawFolder,
    };
}
